export default __webpack_public_path__ + "static/media/Guru-Parampara-11.8f5b541a.png";